var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_286_830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.79175 2.83325H2.83341C2.45769 2.83325 2.09736 2.98251 1.83168 3.24818C1.566 3.51386 1.41675 3.8742 1.41675 4.24992V14.1666C1.41675 14.5423 1.566 14.9026 1.83168 15.1683C2.09736 15.434 2.45769 15.5833 2.83341 15.5833H12.7501C13.1258 15.5833 13.4861 15.434 13.7518 15.1683C14.0175 14.9026 14.1667 14.5423 14.1667 14.1666V9.20825",
    stroke: "#C82929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1042 1.77091C13.386 1.48912 13.7682 1.33081 14.1667 1.33081C14.5653 1.33081 14.9475 1.48912 15.2292 1.77091C15.511 2.05271 15.6694 2.4349 15.6694 2.83341C15.6694 3.23193 15.511 3.61412 15.2292 3.89591L8.50008 10.6251L5.66675 11.3334L6.37508 8.50008L13.1042 1.77091Z",
    stroke: "#C82929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_286_830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.99b36ddc5b64b46e6e304313a2051589.svg";
export { ForwardRef as ReactComponent };